import Avatar from "../../assets/images/avatar.svg";

const PopoverTitle = (
  <div className="popover-title-container">
    <img src={Avatar} alt="Avatar" />
    <span>
      <strong>Todd</strong> from Vence
    </span>
  </div>
);

export default PopoverTitle;
